import React from "react"
import "./Amenities.scss"

const CanadaAmenities = ({ showtext, amenities }) => {
  

  return (
    <div className="schedule-canada-amenities">
      {showtext ? <p>
        Landline is the most convenient and cost-effective way to travel to the airport, saving you
        money on gas, tolls, expensive Toronto Airport parking fees, vehicle wear and tear, and time
        spent navigating traffic. We take the stress out of your travel experience by handling the
        driving, allowing you to relax and enjoy the following premium onboard amenities:
      </p> : null}
      <div className="schedule-canada-amenities-list">
        {amenities.map((item, index) => {
          return (
            <div key={index} className="schedule-canada-amenities-item">
              {item.icon}
              <h4>{item.title}</h4>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CanadaAmenities
